import { useMemo } from 'react';
import MobileDownloadPageBase from '../../components/common/MobileDownloadPageBase';
import MobileHeader from '../../components/common/MobileHeader';
import MobileFooter from '../../components/common/MobileFooter';
import { ErrorMessages } from '../../components/metro/ErrorCodes';

/**
 * Metro mobile app download page
 * Wrapper around generic MobileDownloadPageBase with Metro-specific configuration
 */
export default function MetroDownloadPage() {
  const config = useMemo(() => ({
    partnerName: 'Metro',
    affiliateId: process.env.REACT_APP_METRO_AFFILIATE_ID,
    brandingId: process.env.REACT_APP_METRO_BRANDING_ID,
    analyticsId: process.env.REACT_APP_METRO_GOOGLE_ANALYTICS_ID,
    supportedPlatformsEnvVar: 'REACT_APP_METRO_SUPPORTED_PLATFORMS',
    urlConfig: {
      android: process.env.REACT_APP_METRO_ANDROID_STORE_URL,
      iphone: process.env.REACT_APP_METRO_IOS_STORE_URL,
    },
    errorCodeMap: {
      invalid_platform: 'M-001',
      unsupported_platform: 'M-002',
      download_failed: 'M-003',
      unexpected_error: 'M-004',
      network_error: 'M-005',
    },
  }), []);

  return (
    <MobileDownloadPageBase
      HeaderComponent={MobileHeader}
      FooterComponent={MobileFooter}
      config={config}
      errorMessages={ErrorMessages}
      pageTitle="Download McAfee Security for Metro"
      pageSubtitle="Protect your mobile device. Select your device type to download now."
      disclaimer="By downloading this app, you agree to McAfee's Terms of Service and Privacy Policy."
    />
  );
}
